import React from "react";
import Card from "../../componentes/contenedores/Card";
import PerfilCliente from "../../componentes/contenedores/PerfilCliente";
import Page from "../../componentes/plantilla/Page";
import { useContextUsuario } from "../../contexto/usuario/UsuarioContext";

const HomeClientes = () => {
  const { usuario } = useContextUsuario();

  const datos = {
    titulo: {
      titulo: "Edicion de perfil",
      url: "/app/clientes/home",
      tituloUrl: "clientes/Home",
      nombreUrl: "Home Clientes",
    },
  };

  return (
    <Page datos={datos}>
      <Card titulo="Perfil de usuario">
        <PerfilCliente datos={ usuario.datoPersonales} />
      </Card>
    </Page>
  );
};

export default HomeClientes;
